import { LETTER_WIDTH } from '../../../constants';
import { ColumnTable, TableRecord } from '@common/types';

export const getColumnWidthByTypeOrName = <R extends TableRecord>(typeWidth: number, name: ColumnTable<R>['title']): number => {
  const nameWidth = name?.toString().length ? name.toString().length * LETTER_WIDTH : typeWidth;
  return Math.max(typeWidth, nameWidth);
};
